import { useState, useEffect, useContext, useRef } from 'react';

import { requestApi } from '../../../../../util/utility';
import { cmnContext } from '../../../../common/CmnContext';
import { SaleListContext } from '../../SaleListContext';

import { SaleModel } from '../../../../../models/sale/Sale';


export function SaleDetailFavorite(props: any) {

  const sale = props.sale;

  const isPc = useContext(cmnContext).isPc;

  const getUpdatedSaleInAllTypes = useContext(SaleListContext).getUpdatedSaleInAllTypes;
  const defaultSaleTypeList = useContext(SaleListContext).defaultSaleTypeList;
  const saleTypeList = useContext(SaleListContext).saleTypeList;
  const setSaleTypeList = useContext(SaleListContext).setSaleTypeList;

  const searchTypeList = useContext(SaleListContext).searchTypeList;
  const setDispSaleList = useContext(SaleListContext).setDispSaleList;
  const setDetailSale = useContext(SaleListContext).setDetailSale;
  const favoriteColor = useContext(SaleListContext).favoriteColor;

  const [isFav, setIsFav] = useState<boolean>(sale.is_favorite);


  // 表示中の動画データ更新
  function updateSaleData(newIsFav: boolean) {
    if(
      searchTypeList.favorite &&
      !newIsFav
    ) {
      // お気に入り一覧表示：解除した場合は削除
      setDispSaleList((prevList: SaleModel[]) => {
        const newList = prevList.filter(s => s.id !== sale.id);
        return [...newList];
      });

    } else {
      // 一覧更新
      setDispSaleList((prevList: SaleModel[]) => {
        const newList = prevList.map(s =>
          s.id === sale.id ? { ...s, is_favorite: newIsFav } : s
        );
        return [...newList];
      });

      // 保存用全件更新
      sale.is_favorite = newIsFav; 
      let newSaleTypeList = getUpdatedSaleInAllTypes(saleTypeList, sale);
      // お気に入り一覧の更新
      let favoriteTypeSaleList = newSaleTypeList['favorite'];
      if(favoriteTypeSaleList && favoriteTypeSaleList.length>0) {
        if(newIsFav) {
          // 追加
          favoriteTypeSaleList = [sale, ...favoriteTypeSaleList];
        } else {
          // 削除
          favoriteTypeSaleList = favoriteTypeSaleList.filter((s: SaleModel) => s.id !== sale.id);
        }
        newSaleTypeList['favorite'] = favoriteTypeSaleList;
      }
      // 更新 
      setSaleTypeList(newSaleTypeList);
    }

    // 詳細オーバーレイの表示更新
    setDetailSale({ ...sale, is_favorite: newIsFav });
  }


  // お気に入り反転
  const onPress = async () => {
    const befIsFav = isFav;
    try {
      // 表示反転
      const newIsFav = !isFav;
      setIsFav(newIsFav);
      // (API)お気に入り反転処理
      requestApi({
        inc: '/backend/api/favorite',
        target_table_index: 1,
        target_id: sale.id,
      }).then(resp => {
        // 接続成功
        if(resp.result == 'success') {
          // 処理成功:動画データ更新
          updateSaleData(newIsFav);
        } else {
          // 処理失敗
          setIsFav(befIsFav);
        }
      }).catch(err => {
        setIsFav(befIsFav);
      })
    } catch(err) {
      setIsFav(befIsFav);
    }
  }


  return (
    <p
      className="btn btn-danger"
      style={{
        margin: '0px 0px',
        padding: isPc? '7px 20px' : '8px 15px',
        border: 0,
        fontSize: isPc? '100%' : '85%',
        backgroundColor: isFav? favoriteColor : '#F9C1CF',
      }}
      onClick={onPress}
    >
      <i className="fas fa-heart" style={{marginRight: 5}}></i>お気に入り
    </p>
  );
}